import { Route, Routes, Navigate } from "react-router-dom"
import { Provider } from "react-redux"
import { DashboardUser } from "@hydrologiq/common/providers/FirebaseAuth"
import store from "./state/store"
import Providers from "@hydrologiq/shared/providers/Providers"
import { RouteProvider, Section } from "@hydrologiq/shared/providers/RouteProvider"
import ScrollToTop from "@hydrologiq/shared/ScrollToTop"
import ConnectionsView from "@hydrologiq/connections/views/ConnectionsView"

function Routing(props: { basePath?: string; user?: DashboardUser; container?: React.RefObject<HTMLElement> }) {
  const sectionPath = "connections"
  const { basePath = sectionPath, user, container } = props

  return (
    <Provider store={store}>
      <ScrollToTop />
      <Routes>
        {!basePath && <Route path={sectionPath} element={<Navigate to={"/"} />} />}
        <Route
          path={basePath}
          element={
            <RouteProvider route={basePath} section={Section.CONNECTIONS}>
              <Providers container={container} user={user} />
            </RouteProvider>
          }
        >
          <Route index element={<ConnectionsView />} />
        </Route>
      </Routes>
    </Provider>
  )
}

export default Routing
